import {Env} from 'admin/types'
import {createEnvInjector, createRootInjector} from 'common/lib/mst-utils'

import {UserType} from './User'
import {RoleManagerType} from './RoleManager'
import {CttStoreType} from './ctt/Store'

// это магия, но мы должны экспортировать этот тип, чтобы не было проблем с циклическими зависимостями :(
export type InjectableModels = {
  user: UserType
  roleManager: RoleManagerType
  ctt: CttStoreType
}

export const injectFromEnv = createEnvInjector<Env>()
export const injectFromRoot = createRootInjector<InjectableModels>()
